import { ErrorMessage } from '@occc-app/lib/ErrorMessage';

/* Action Types */
const LIMIT_COMPONENT_ERR = 'hq/Offer/Limits/LIMIT_COMPONENT_ERR';
const LIMIT_COMPONENT_OK = 'hq/Offer/Limits/LIMIT_COMPONENT_OK';
const LIMIT_COMPONENTS_ERR = 'hq/Offer/Limits/LIMIT_COMPONENTS_ERR';
const LIMIT_COMPONENTS_OK = 'hq/Offer/Limits/LIMIT_COMPONENTS_OK';
const LIMIT_CONFIGURATION_UPDATE = 'hq/Offer/Limits/LIMIT_CONFIGURATION_UPDATE';
const LIMIT_TOGGLE_UPDATE = 'hq/Offer/Limits/LIMIT_TOGGLE_UPDATE';
const REQUEST_LIMIT = 'hq/Offer/Limits/REQUEST_LIMIT';
const REQUEST_LIMIT_ERR = 'hq/Offer/Limits/REQUEST_LIMIT_ERR';
const REQUEST_LIMIT_OK = 'hq/Offer/Limits/REQUEST_LIMIT_OK';
const REQUEST_LIMITS_OK = 'hq/Offer/Limits/REQUEST_LIMITS_OK';
const RESET_INITIAL_LIMITS_STATE = 'hq/Offer/Limits/RESET_INITIAL_LIMITS_STATE';

type Types = {
  LIMIT_COMPONENT_ERR: typeof LIMIT_COMPONENT_ERR;
  LIMIT_COMPONENT_OK: typeof LIMIT_COMPONENT_OK;
  LIMIT_COMPONENTS_ERR: typeof LIMIT_COMPONENTS_ERR;
  LIMIT_COMPONENTS_OK: typeof LIMIT_COMPONENTS_OK;
  LIMIT_CONFIGURATION_UPDATE: typeof LIMIT_CONFIGURATION_UPDATE;
  LIMIT_TOGGLE_UPDATE: typeof LIMIT_TOGGLE_UPDATE;
  REQUEST_LIMIT: typeof REQUEST_LIMIT;
  REQUEST_LIMIT_ERR: typeof REQUEST_LIMIT_ERR;
  REQUEST_LIMIT_OK: typeof REQUEST_LIMIT_OK;
  REQUEST_LIMITS_OK: typeof REQUEST_LIMITS_OK;
  RESET_INITIAL_LIMITS_STATE: typeof RESET_INITIAL_LIMITS_STATE;
};

const types: Types = {
  LIMIT_COMPONENT_ERR,
  LIMIT_COMPONENT_OK,
  LIMIT_COMPONENTS_ERR,
  LIMIT_COMPONENTS_OK,
  LIMIT_CONFIGURATION_UPDATE,
  LIMIT_TOGGLE_UPDATE,
  REQUEST_LIMIT,
  REQUEST_LIMIT_ERR,
  REQUEST_LIMIT_OK,
  REQUEST_LIMITS_OK,
  RESET_INITIAL_LIMITS_STATE,
};

// Limits
export const GLOBAL_LIMIT = 'globalLimit';
export const MEMBERSHIP_LIMIT = 'membershipLimit';

export type LimitKeys = typeof GLOBAL_LIMIT | typeof MEMBERSHIP_LIMIT;

export type GlobalLimit = {
  type: typeof GLOBAL_LIMIT;
  active: boolean;
  limit: number;
};

export type MembershipLimit = {
  type: typeof MEMBERSHIP_LIMIT;
  active: boolean;
  limit: number;
};

export type Limits = GlobalLimit | MembershipLimit;

// Actions
type LimitComponentERR = (
  limitType: LimitKeys,
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof LIMIT_COMPONENT_ERR;
  limitType: LimitKeys;
  errorMessages: ErrorMessage[];
  error: Error;
};

type LimitComponentOK = (
  limitType: LimitKeys,
  id: string,
) => {
  type: typeof LIMIT_COMPONENT_OK;
  limitType: LimitKeys;
  id: string;
};

type LimitComponentsERR = (
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof LIMIT_COMPONENTS_ERR;
  errorMessages: ErrorMessage[];
  error: Error;
};

type LimitComponentsOK = () => {
  type: typeof LIMIT_COMPONENTS_OK;
};

type LimitConfigurationUpdate = (
  limitConfigurationKey: string,
  key: string,
  value: any,
) => {
  type: typeof LIMIT_CONFIGURATION_UPDATE;
  limitConfigurationKey: string;
  key: string;
  value: any;
};

type LimitToggleUpdate = (limitConfigurationKey: string) => {
  type: typeof LIMIT_TOGGLE_UPDATE;
  limitConfigurationKey: string;
};

type RequestLimit = (
  id: string,
  limitType: LimitKeys,
) => {
  type: typeof REQUEST_LIMIT;
  id: string;
  limitType: LimitKeys;
};

type RequestLimitERR = (
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof REQUEST_LIMIT_ERR;
  errorMessages: ErrorMessage[];
  error: Error;
};

type RequestLimitOK = (selectedLimit: Limits) => {
  type: typeof REQUEST_LIMIT_OK;
  selectedLimit: Limits;
};

type RequestLimitsOK = () => {
  type: typeof REQUEST_LIMITS_OK;
};

type ResetInitialLimitsState = (limits: Limits) => {
  type: typeof RESET_INITIAL_LIMITS_STATE;
  limits: Limits;
};

export type Action =
  | ReturnType<LimitComponentERR>
  | ReturnType<LimitComponentOK>
  | ReturnType<LimitComponentsERR>
  | ReturnType<LimitComponentsOK>
  | ReturnType<LimitConfigurationUpdate>
  | ReturnType<LimitToggleUpdate>
  | ReturnType<RequestLimit>
  | ReturnType<RequestLimitERR>
  | ReturnType<RequestLimitOK>
  | ReturnType<RequestLimitsOK>
  | ReturnType<ResetInitialLimitsState>;

export type ActionCreators = {
  LimitComponentERR: LimitComponentERR;
  LimitComponentOK: LimitComponentOK;
  LimitComponentsERR: LimitComponentsERR;
  LimitComponentsOK: LimitComponentsOK;
  LimitConfigurationUpdate: LimitConfigurationUpdate;
  LimitToggleUpdate: LimitToggleUpdate;
  RequestLimit: RequestLimit;
  RequestLimitERR: RequestLimitERR;
  RequestLimitOK: RequestLimitOK;
  RequestLimitsOK: RequestLimitsOK;
  ResetInitialLimitsState: ResetInitialLimitsState;
};

/* State Types */
type AwardCountErrorMessage = {
  property?: 'limit';
  message: string;
};

type OfferComponentMetaData = {
  error: Error | null;
  errorMessages: AwardCountErrorMessage[];
  id: string;
  dirty: boolean;
  submitting: boolean;
};

type GlobalLimitState = OfferComponentMetaData & GlobalLimit;
type MembershipLimitState = OfferComponentMetaData & MembershipLimit;
export type LimitState = GlobalLimitState | MembershipLimitState;

export type State = {
  globalLimit: GlobalLimitState;
  membershipLimit: MembershipLimitState;
  error: Error | null;
  errorMessages: ErrorMessage[];
  requesting: boolean;
};

export default types;
